import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import EnhancedToolbar from '../../../widgets/Toolbar';
import { OnlineProviderForm } from './OnlineProviderForm';
import ViewUtils from '../../../ViewUtils';
import { ViewContainer } from "../../../View.jsx";

const utils = new ViewUtils();

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'back', label: 'BACK', tooltip: 'Back to SDL Number search', theme: true },
                { id: 'next', label: 'NEXT', tooltip: 'Proceed to add learnership scope', theme: true }
            ]
        }
    ]
};
const formRef = React.createRef();
class AddOnlineProviderDetails extends Component {
    constructor(props) {
        super(props)
        let data = {};

        console.log(props.data);

        if (!utils.isNull(props.data) && !utils.isNull(props.data.providerRoleDetails)) {
            if (!utils.isNull(props.data.providerRoleDetails.Provider)) {
                data = props.data.providerRoleDetails.Provider;
            }
            else {
                data = props.data.providerRoleDetails;
            }
        } else if (!utils.isNull(props.data) && !utils.isNull(props.data.providerIdentityDetails)) {
            data = props.data.providerIdentityDetails.Provider ? props.data.providerIdentityDetails.Provider : props.data.providerIdentityDetails.formData
        } else {
            data.Provider = {};
        }

        this.state = {
            model: data
        }
    }

    handleFormValueChange() {
    }

    handleToolbarButtonClick(buttonId) {
        let formValue = formRef.current.getValue();
        if ("back" === buttonId) {
            this.props.stepHandler(1, false, formValue);
        } else if ("next" === buttonId) {
            if (!utils.isNull(formValue)) {
                this.props.stepHandler(1, true, formValue);
            }
        }
    }

    render() {
        return (
            <ViewContainer topPadding="0">
                <p className="legend">
                    Online Provider Registration Details
                </p>
                <div style={{ height: "50%", maxHeight: "42vh" }}>
                    <OnlineProviderForm ref={formRef} data={this.state.model} IsExternal={this.props.IsExternal} valueChangeHandler={(values) => this.handleFormValueChange(values)} editPermission={true} />
                </div>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="90%">
                            </td>
                            <td width="20%" align="right">
                                <div style={{ width: "120px", marginTop: "16px" }}>
                                    <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)} config={toolbarConfig} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(AddOnlineProviderDetails)
);
